var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("trading-name"),
        required: "",
        state: _vm.getState(_vm.$v.recipient.trading_name),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.trading_name),
      },
    },
    [
      _c("EmdInput", {
        attrs: {
          name: "trading_name",
          readonly: _vm.disabled,
          disabled: _vm.disabled,
        },
        on: { input: () => _vm.$v.recipient.trading_name.$touch() },
        model: {
          value: _vm.recipient.trading_name,
          callback: function ($$v) {
            _vm.$set(_vm.recipient, "trading_name", $$v)
          },
          expression: "recipient.trading_name",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }